import { useApolloClient } from '@vue/apollo-composable'
import { i18nObject } from 'boot/i18n.js'
import { consumeSocialAuthRedirectState } from 'boot/init-core/handle-auth/social-auth-redirect.js'
import { BASE_URL } from 'common/config.js'
import { APOLLO_CLIENTS } from 'common/dictionary.js'
import { checkMirrorAndRedirect, consoleLogAPI } from 'common/functions.js'
import { tokenService } from 'common/token-service.js'
import { notification } from 'core/hooks/notifications.js'
import { useUserAuthStore } from 'stores/user/auth.js'
import { getConfig } from '@/configs/index.js'

const config = getConfig()

export async function handleNotAuth({ router, urlPath }) {
  const url = urlPath.replace(BASE_URL, '')
  const route = router.resolve(url)
  const isPendingSocialRegistration = route.name === 'auth-social' && Boolean(route.query?.temp_token)
  const { redirectPath, resumePath } = consumeSocialAuthRedirectState({
    preserveLinkAfterAuth: isPendingSocialRegistration,
  })

  const userAuthStore = useUserAuthStore()

  if (route.name === 'auth-social') {
    if (!Object.keys(route.query).length) {
      const routeTo = redirectPath || { name: 'Home' }
      setTimeout(() => {
        notification({ type: 'warning', text: i18nObject.global.t('socialAuthError') })
      }, 200)
      return routeTo
    }

    const hasSocialAuthToken = route.query?.token || route.query?.ussid

    if (hasSocialAuthToken) {
      tokenService.setToken(route.query.token, route.query.ussid)

      localStorage.setItem('hasAccount', 'true')

      const { resolveClient } = useApolloClient()
      const apolloClient = resolveClient()
      const apolloClientGo = resolveClient(APOLLO_CLIENTS.clientGo)

      userAuthStore.updateToken(route.query.token)

      if (!config.useMirrors) {
        return redirectPath || { name: 'Home' }
      }

      try {
        await checkMirrorAndRedirect({
          apolloClient,
          apolloClientGo,
          query: { path: redirectPath },
        })
      } catch (e) {
        consoleLogAPI(e)
        throw e
      }
    }

    const isSocialAuthError =
      route.query?.temp_token || route.query?.error || (route.query?.social && !hasSocialAuthToken)

    if (isSocialAuthError) {
      const socialAuthData =
        route.query?.error || route.query?.temp_token ? route.query : { ...route.query, error: 'true' }

      userAuthStore.updateSocialAuthData(socialAuthData)

      if (resumePath) {
        const resumeRoute = router.resolve(resumePath)
        return {
          path: resumeRoute.path,
          query: { ...resumeRoute.query, modal: 'reg' },
          hash: resumeRoute.hash,
        }
      } else {
        return { name: 'Home', query: { modal: 'reg' } }
      }
    }
  }
}
